import { IDriverState } from "./types";


export const initialDriverState: IDriverState = {
	bookingDrivers: []
};


export enum Gender {
  MALE = "Male",
  FEMALE = "Female",
  OTHER = "Other",
  NOTTODISCLOSE = "Prefer not to disclose"
}